module.exports = __webpack_public_path__ + "img/frame (171).31aaaad2.jpg";